jQuery('body').on('mouseover' , '.shop-menu-item', updateShopMenuItem );
jQuery('body').ready(currentMenuItem);
jQuery('body').ready(productDetails);

// update shop menu item href for Salon order roles based on current shopping mode
function updateShopMenuItem () {
    var shopMenuItem       = document.querySelectorAll('.shop-menu-item a')[1];
    var shopMenuItemMobile = document.querySelectorAll('.shop-menu-item a')[0];
    var headerClasses      = document.querySelectorAll('.site-header')[0];

    if (headerClasses.classList.contains('orderer-menu')
        && salon_mode ) {

        shopMenuItem.href       =  '/products/?simode=orderer';
        shopMenuItemMobile.href =  '/products/?simode=orderer';
    }

    else if (headerClasses.classList.contains('orderer-menu')
            && stylist_mode) {

        shopMenuItem.href       =  '/products/?simode=stylist';
        shopMenuItemMobile.href =  '/products/?simode=stylist';
    }

}

// add current-menu-item to menu bar on Product Detail page
function currentMenuItem() {
    var stylistMenuItemMobile = document.querySelectorAll('ul .stylist')[0];
    var stylistMenuItem       = document.querySelectorAll('ul .stylist')[1];
    var salonMenuItemMobile   = document.querySelectorAll('ul .salon')[0];
    var salonMenuItem         = document.querySelectorAll('ul .salon')[1];

    if (salon_mode) {

        if (salonMenuItem != null ) {
            salonMenuItem.setAttribute('class', 'current-menu-item');
        }

        if (salonMenuItemMobile != null ) {
            salonMenuItemMobile.setAttribute('class', 'current-menu-item');
        }

    }

    else if (stylist_mode) {
        if (stylistMenuItem != null ) {
            stylistMenuItem.setAttribute('class', 'current-menu-item');
        }

        if (stylistMenuItemMobile != null ) {
            stylistMenuItemMobile.setAttribute('class', 'current-menu-item');
        }
    }

};

function productDetails() {
    var productDetailPage     = document.querySelectorAll('.single-bigcommerce_product')[0];
    var salonSwitcher         = document.querySelectorAll('#salonswitcher')[1];
    var stylistSwitcher       = document.querySelectorAll('#stylistswitcher')[1];
    var salonSwitcherMobile   = document.querySelectorAll('#salonswitcher')[0];
    var stylistSwitcherMobile = document.querySelectorAll('#stylistswitcher')[0];

    if (productDetailPage) {

        if (salon_mode) {
            stylistSwitcher.classList.add('disabled');
            stylistSwitcherMobile.classList.add('disabled');
        }

        if (stylist_mode) {
            salonSwitcher.classList.add('disabled');
            salonSwitcherMobile.classList.add('disabled');
        }
    }
    
}

